<script>
  import { page } from '@inertiajs/svelte'
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import FilterBar from '../../components/filter_bar.svelte'
  import FilterSelect from '../../components/filter_select.svelte'
  import FilterField from '../../components/filter_field.svelte'
  import { Button } from '../../components/ui'
  import { waitForDownloadCookie } from '../../lib/file_download.js'

  // `filters`: the picks a failed download sent, handed back with its error.
  let { default_days_back = 30, filters = {} } = $props()

  const DOWNLOAD_COOKIE = 'admin_report_download'

  const areas = $derived($page.props.areas || [])

  let areaId = $state(filters.area_id || $page.props.current_area_id || '')
  let placeId = $state(filters.place_id || '')
  let daysBack = $state(filters.days_back ?? default_days_back)
  let loading = $state(false)

  const areaOptions = $derived(areas.map((area) => ({ value: area.id, label: area.name })))

  // Transient picker state: a place from the previous town can't be offered under the new
  // one (the server also rejects a mismatched pair).
  let shownAreaId = areaId
  $effect(() => {
    if (areaId === shownAreaId) return
    shownAreaId = areaId
    placeId = ''
  })

  const download = async () => {
    loading = true
    const token = crypto.randomUUID()
    const url = new URL('/reports/download', window.location.origin)
    if (areaId) url.searchParams.set('area_id', areaId)
    if (placeId) url.searchParams.set('place_id', placeId)
    if (daysBack !== null && daysBack !== '') url.searchParams.set('days_back', daysBack)
    url.searchParams.set('download_token', token)
    window.location.href = `${url.pathname}${url.search}`
    await waitForDownloadCookie(DOWNLOAD_COOKIE, token)
    loading = false
  }
</script>

<Layout>
  <PageHeader title="Exports" subtitle="Export place and area activity as CSV" />

  <FilterBar>
    {#snippet start()}
      <FilterSelect
        label="College Town (optional)"
        value={areaId}
        placeholder="Select college town…"
        options={areaOptions}
        onchange={(v) => (areaId = v)}
      />
      <FilterSelect
        label="Place (optional)"
        value={placeId}
        placeholder="Select place…"
        source="places"
        sourceParams={{ area_id: areaId }}
        onchange={(v) => (placeId = v)}
      />
      <FilterField label="Days Back">
        <input type="number" min="1" class="input input-sm w-40" bind:value={daysBack} />
      </FilterField>
      <Button variant="primary" size="sm" icon="download" loading={loading} onclick={download}>
        Download CSV
      </Button>
    {/snippet}
  </FilterBar>
</Layout>
